import { IUserContext } from '@truckdown/systems';
import registerAccounts from '@truckdown/accounts';

import './Components';

export default {
    registerPrerequisites: (context: IUserContext) => {
        registerAccounts(context);
    }
};